import { getCurrentLocale } from './localeMapping'

export function formatDateTime(date: Date) {
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).format(date)
}

export function formatFullDateTime(date: Date): string {
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    dateStyle: 'full',
    timeStyle: 'long',
  }).format(date)
}

export function formatDayAndMonth(date: Date) {
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    month: 'short',
    day: 'numeric',
  }).format(date)
}

export function formatFullDayAndMonth(date: Date) {
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    dateStyle: 'full',
  }).format(date)
}

export function formatDateMonthAndYear(date: Date) {
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date)
}

/** Full month name plus year, e.g. "June 2026" — used as timeline group header. */
export function formatMonthAndYear(date: Date) {
  const label = new Intl.DateTimeFormat(getCurrentLocale(), {
    year: 'numeric',
    month: 'long',
  }).format(date)
  return label.charAt(0).toUpperCase() + label.slice(1)
}
